import { styled, Typography } from '@mui/material';
import TooltipContentProps from './TooltipContent.props';

const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 'bold',
  marginBottom: theme.spacing(2),
}));

const StyledSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: '15px',
  fontWeight: '600',
  marginBottom: theme.spacing(0.5),
  marginTop: theme.spacing(2),
}));

const StyledParagraph = styled(Typography)({
  fontSize: '14px',
});

export const TooltipContent = ({ title, defaultText, customText }: TooltipContentProps) => (
  <>
    <StyledTitle>{title}</StyledTitle>

    <StyledSubtitle>Default (unselected)</StyledSubtitle>
    <StyledParagraph>{defaultText}</StyledParagraph>

    <StyledSubtitle>Custom (selected)</StyledSubtitle>
    <StyledParagraph>{customText}</StyledParagraph>
  </>
);
